import { render } from "./Index.vue?vue&type=template&id=0555d390&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=0555d390&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0555d390"]])

export default __exports__